const BC_SavedReport = function (EWS) {
    const me = this;

    this.EWS = EWS;
    this.UserName = "";
    this.FullName = "";
    this.UserId = 0;
    // Task 726729: Create dashboard widget to display a selected list of reports in a 'Report Library UI' format
    this.SelectedReportIDArr = [];

    this.EWS.Command.Add("BC_SavedReport_GetReports", (control, args) => {
        EWS.VerifySession(() => {
            ECP.Dialog.ShowLoading();

            if (args.ownerauthenticationid === undefined && AuthenticationID) {
                args.ownerauthenticationid = AuthenticationID;
            }
            if (!args.ownerauthenticationid || EC_Fmt.isNull(parseInt(args.ownerauthenticationid))) {
                args.ownerauthenticationid = "0";
            }
            const myRequest = new ECP.EC_Request("SavedReport_GetReports");
            myRequest.AddRequestVariable("OwnerAuthenticationID", args.ownerauthenticationid);

            if (args.search) {
                // Task 662357: Run Test Case 3968 Fail : Can not search this Fusion Report in Dashboard Report Search
                myRequest.AddRequestVariable("SearchStr", args.search);
            }
            // Task 667701: Improve performance when saving a fusion report that has 'columns' on it - Prevent 'Columns' reports from being used as base reports
            if (args.FilterPivot) {
                myRequest.AddRequestVariable("FilterPivot", args.FilterPivot);
            }

            if (args.DashboardID) {
                if (Array.isArray(args.DashboardID)) {
                    myRequest.AddRequestVariable("DashboardID", args.DashboardID.join(","));
                } else {
                    myRequest.AddRequestVariable("DashboardID", args.DashboardID);
                }
            }

            if (this.SelectedReportIDArr.length > 0) {
                myRequest.AddRequestVariable("SelectedReportID", this.SelectedReportIDArr.join(","));
            }

            myRequest.Submit().then((results) => {
                ECP.Dialog.HideLoading();

                let html = "";
                const reportDisplay = args.Dialog.querySelector("#ews-report-display");

                const shared = results.owner;

                for (let i = 0; i < shared.length; i++) {
                    html += "<div class=ews-tree-node>";

                    if (shared.length === 1) {
                        html += "  <div class=\"ews-tree-trigger ews-tree-selector ews-tree-expanded\"></div>";
                        html += "  <div class=ews-tree-folder-icon></div>";
                        html += `  <a class="ews-tree-node-item" type="folder">${shared[i].name}</a>`;
                        html += "  <div class=ews-tree-child-node style=\"display: block;\">";
                    } else {
                        html += "  <div class=\"ews-tree-trigger ews-tree-selector ews-tree-collapsed\"></div>";
                        html += "  <div class=ews-tree-folder-icon></div>";
                        html += `  <a class="ews-tree-node-item" type="folder">${shared[i].name}</a>`;
                        html += "  <div class=ews-tree-child-node>";
                    }

                    for (let j = 0; j < shared[i].catagory.length; j++) {
                        if (shared[i].catagory[j].name === "") {
                            for (let k = 0; k < shared[i].catagory[j].report.length; k++) {
                                // 1) Pivot 2)Data
                                const IsPivot = shared[i].catagory[j].report[k].reporttype === 1;
                                html += `<div class="ews-tree-node ${IsPivot ? "disabled" : ""}" ${IsPivot ? "title=\"cannot use this report as a source, it contains child or details rows.\"" : ""}>`;
                                html += "  <div class=\"ews-tree-trigger ews-tree-selector\"></div>";
                                html += "  <div class=ews-tree-select-icon>";

                                // Task 1011667: Include all reports in the report selector for Import Routines, but disable the ones that are not supported, with an explanation of why it can't be used
                                if (IsPivot) {
                                    html += `<input type="${args.multipleSelect ? "checkbox" : "radio"}"  ${args.multipleSelect ? "onclick=\"return false;\"" : "disabled"}/>`;
                                } else {
                                    html += `<input type="${args.multipleSelect ? "checkbox" : "radio"}" ${args.multipleSelect && this.SelectedReportIDArr.indexOf(shared[i].catagory[j].report[k].id.toString()) > -1 ? "checked" : ""} name="saved-report" source="${shared[i].catagory[j].report[k].source}" owner="${shared[i].owner}" fullname="${shared[i].name}" value="${shared[i].catagory[j].report[k].id}" category="${shared[i].catagory[j].name}" />`;
                                }
                                html += "  </div>";
                                html += `  <a class=ews-tree-node-item ${IsPivot ? "" : "type=report"}>${shared[i].catagory[j].report[k].name}</a>`;
                                html += "</div>";
                            }
                        } else {
                            html += "<div class=ews-tree-node>";
                            html += "  <div class=\"ews-tree-trigger ews-tree-selector ews-tree-collapsed\"></div>";
                            html += "  <div class=ews-tree-folder-icon></div>";
                            html += `  <a class="ews-tree-node-item" type="folder">${shared[i].catagory[j].name}</a>`;
                            html += "  <div class=ews-tree-child-node>";

                            for (let k = 0; k < shared[i].catagory[j].report.length; k++) {
                                const IsPivot = shared[i].catagory[j].report[k].reporttype === 1;
                                html += `<div class="ews-tree-node ${IsPivot ? "disabled" : ""}" ${IsPivot ? "title=\"cannot use this report as a source, it contains child or details rows.\"" : ""}>`;
                                html += "  <div class=\"ews-tree-trigger ews-tree-selector\"></div>";
                                html += "  <div class=ews-tree-select-icon>";
                                if (IsPivot) {
                                    html += `<input type="${args.multipleSelect ? "checkbox" : "radio"}" title='cannot use this report as a source, it contains child or details rows.' ${args.multipleSelect ? "onclick=\"return false;\"" : "disabled"}/>`;
                                } else {
                                    html += `<input type="${args.multipleSelect ? "checkbox" : "radio"}" ${args.multipleSelect && this.SelectedReportIDArr.indexOf(shared[i].catagory[j].report[k].id.toString()) > -1 ? "checked" : ""} name="saved-report" source="${shared[i].catagory[j].report[k].source}" owner="${shared[i].owner}" fullname="${shared[i].name}" value="${shared[i].catagory[j].report[k].id}" category="${shared[i].catagory[j].name}" />`;
                                }
                                html += "  </div>";
                                html += `  <a class=ews-tree-node-item ${IsPivot ? "" : "type=report"}>${shared[i].catagory[j].report[k].name}</a>`;
                                html += "</div>";
                            }

                            html += "  </div>";
                            html += "</div>";
                        }
                    }

                    html += "  </div>";
                    html += "</div>";
                }

                reportDisplay.innerHTML = html;

                if (args && args !== undefined && (args.report || (args.multipleSelect && this.SelectedReportIDArr.length > 0))) {
                    // Task 923438: Dashboard Report Widget: Editing a Dashboard forces me to re-select the Report
                    const reportIdArr = args.multipleSelect ? this.SelectedReportIDArr : [args.report];

                    for (let i = 0; i < reportIdArr.length; i++) {
                        const reportId = reportIdArr[i];
                        const reportInput = args.Dialog.querySelector(`#ews-report-display input[type=${args.multipleSelect ? "checkbox" : "radio"}][value='${reportId}']`);
                        if (reportInput) {
                            reportInput.checked = true;
                            let treeNode = reportInput.closest(".ews-tree-node");
                            // Task 1034256: Show report already selected in report widget on dashboards
                            if (!args.multipleSelect) {
                                const currentSavedReports = EC_Fmt.HtmlStrToElement("<div class=currentSavedReports></div>");
                                reportDisplay.prepend(currentSavedReports);
                                currentSavedReports.prepend(treeNode);
                            }
                            // Expands the Report tree by default.
                            const NodeArray = [];
                            while (treeNode) {
                                NodeArray.push(treeNode);
                                if (treeNode.parentNode && !treeNode.parentNode.closest(".ews-tree-node")) {
                                    break;
                                }
                                treeNode = treeNode.parentNode.closest(".ews-tree-node");
                            }
                            NodeArray.forEach((node) => {
                                if (node.querySelector(".ews-tree-collapsed")) {
                                    node.querySelector(".ews-tree-collapsed").click();
                                }
                            });
                        }
                    }
                }

                if (args.multipleSelect) {
                    EC_Fmt.TriggerEvent(args.Dialog.querySelector("#ews-report-title"), "keyup");

                    const ownerNodeSet = new Set();
                    const checkedInputArr = document.querySelectorAll("input[type=checkbox]:checked");

                    for (let i = 0; i < checkedInputArr.length; i++) {
                        const checkedInput = checkedInputArr[i];
                        const ownerNode = checkedInput.closest("#ews-report-display > .ews-tree-node");

                        ownerNodeSet.add(ownerNode);
                    }

                    const ownerNodeArr = Array.from(ownerNodeSet);

                    for (let i = ownerNodeArr.length - 1; i > 0; i--) {
                        const ownerNode = ownerNodeArr[i];

                        document.getElementById("ews-report-display").insertBefore(ownerNode, document.getElementById("ews-report-display").firstElementChild);
                    }

                    args.Dialog.addEventListener("click", (event) => {
                        if (event.target.matches("input[type='checkbox']")) {
                            const checkbox = event.target;

                            if (checkbox.checked) {
                                this.SelectedReportIDArr.push(checkbox.value);
                            } else {
                                const index = this.SelectedReportIDArr.indexOf(checkbox.value);

                                if (index > -1) {
                                    this.SelectedReportIDArr.splice(index, 1);
                                }
                            }
                        }
                    });
                }
            });
        });
    });
};

BC_SavedReport.prototype.Delete = function (id, trigger) {
    const me = this;
    // Task 726325: Save Fusion report is very very slow, and does not give the user a 'saving' message of any kind
    me.ConfirmDelete(id, trigger, EC_Fmt.Trn("Are you sure you want to delete this saved report?"));
};

BC_SavedReport.prototype.ConfirmDelete = function (id, trigger, message) {
    const html = "<table style=width:100%;height:100% class=NoPadding>"
        + "<tr>"
        + `<td style="text-align:center;font-size:16px">${message}</td>`
        + "</tr>"
        + "</table>";

    const dialogConfirm = ECP.Dialog.ShowDialog("Confirm", html, {
        cancelButtonTitle: "Cancel",
        confirmButtonAction(dialog) {
            ECP.Dialog.CloseDialog(dialog);

            ECP.Dialog.ShowLoading();

            const myRequest = new ECP.EC_Request("SavedReport_DeleteReport");
            myRequest.AddRequestVariable("ReportID", id);

            myRequest.Submit().then((result) => {
                if (trigger) {
                    document.querySelectorAll(trigger).forEach((item) => {
                        item.remove();
                    });
                }

                ECP.Dialog.HideLoading();

                if (result.success !== "True") {
                    ECP.Dialog.Alert("Unable to delete report");
                }
            }).catch((error) => {
                ECP.Dialog.HideLoading();
                throw error;
            });
        }
    });

    dialogConfirm.firstChild.style.height = "200px";
};

BC_SavedReport.prototype.Edit = function (id) {
    const me = this;

    if (id && !EC_Fmt.isNull(parseInt(id))) {
        EWS.VerifySession(() => {
            const myRequest = new ECP.EC_Request("SavedReport_GetReport");
            myRequest.AddRequestVariable("ReportID", id);

            myRequest.Submit().then((result) => {
                if (result.error) {
                    EWS.HideLoading();
                    ECP.Dialog.Alert(result.error);
                    return;
                }
                const args = {
                    id: parseInt(id),
                    document: result.document,
                    name: result.name,
                    DashboardID: result.DashboardID,
                    format: result.format,
                    category: result.category,
                    owner: result.owner,
                    ownerauthenticationid: result.ownerauthenticationid,
                    favorite: result.favorite,
                    link: result.link,
                    roles: result.roles
                };

                me.Show_BC_SavedReport_EditReport_Dialog(args);
            });
        });
    } else {
        ECP.Dialog.Alert(EC_Fmt.Trn("Invalid Report ID"));
    }
};

BC_SavedReport.prototype.Favorite = function (event, ReportURL, Name) {
    if (ReportURL === "") {
        ReportURL = window.location.href.substring(window.location.href.indexOf("/Home?") + 1);
    }

    const myRequest = new ECP.EC_Request("GetFavoritesDialog");
    myRequest.AddRequestVariable("FavoriteURL", ReportURL);
    // Task 615639: Favoriting Reports with Names Longer than 50 Characters Prevents TextArea from Generating and Throws Error Upon Save
    myRequest.AddRequestVariable("FavoriteName", Name.substring(0, 50));

    myRequest.Submit().then((result) => {
        const RemoveFavorite = result.RemoveFavorite === "true";
        ECP.Dialog.ShowDialog(RemoveFavorite ? "Remove Favorite?" : "Save Favorite?", result.html, {
            Width: 460,
            disableResize: true,
            cancelButtonTitle: "Cancel",
            confirmButtonTitle: RemoveFavorite ? "Remove" : "Save",
            confirmButtonAction: (Dialog) => {
                clearDashboardMenuCache();

                let NewName = "";
                if (!RemoveFavorite) {
                    NewName = Dialog.getElementsByClassName("FavoritesName")[0].value;
                } else {
                    NewName = `DeleteRecord_${result.ID}`;
                }
                if (RemoveFavorite || NewName !== "") {
                    // Task 624857: SystemError: UnknownFile:JavaScript Error: UnknownFile (0) - Error in promise - TypeError: Failed to fetch
                    const myRequest = new ECP.EC_Request("UpdateFavorite");
                    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
                    myRequest.AddRequestVariable("ID", result.ID);
                    myRequest.AddRequestVariable("Name", NewName);
                    if (!RemoveFavorite) {
                        myRequest.AddRequestVariable("FavoriteURL", ReportURL, ECP.EC_Verb.Post);
                    }
                    myRequest.Submit().then(() => {
                        window.location.reload();
                    }).catch((error) => {
                        ECP.Dialog.HideLoading();
                        throw new Error(`Error saving to favorites ${error}`);
                    });
                } else if (NewName === "") {
                    ECP.Dialog.Alert("Name can not be empty");
                }
            }
        });
    });
};

BC_SavedReport.prototype.LoadRoles = function (dialog, selected) {
    EWS.VerifySession(() => {
        const myRequest = new ECP.EC_Request("SavedReport_GetSharingRoles");

        myRequest.Submit().then((result) => {
            // Task 940845: Update Report Sharing Roles to group by User Type and limit view by UserType.ViewPermission IN {UserPermissionArr}

            const UserTypeArr = [];
            const UserTypeRoles = result.roles.reduce((userTypeRoles, role) => {
                if (!UserTypeArr.includes(role.UserType)) {
                    UserTypeArr.push(role.UserType);
                }
                const roles = userTypeRoles[role.UserType] || (userTypeRoles[role.UserType] = []);
                roles.push(role);
                return userTypeRoles;
            }, {});

            let html = "<div class='ews-savedreport-roles-container ews-tree-panel usertypeall'>";
            for (let i = 0; i < UserTypeArr.length; i++) {
                let selectCount = 0;
                let roleshtml = "";
                const userType = UserTypeArr[i];
                const roles = UserTypeRoles[userType];
                for (let z = 0; z < roles.length; z++) {
                    roleshtml += "<div>";
                    roleshtml += `<div class="ews-tree-selector"></div>`;
                    roleshtml += `<div class=ews-tree-select-icon>`;

                    if (selected && selected.indexOf(EC_Fmt.Null2ZeroInt(roles[z].RoleID)) >= 0) {
                        roleshtml += `<input type=checkbox class="ews-checkbox ews-contact" id=SharingRole${roles[z].RoleID} value="${roles[z].RoleID}" checked>`;
                        selectCount++;
                    } else {
                        roleshtml += `<input type=checkbox class="ews-checkbox ews-contact" id=SharingRole${roles[z].RoleID} value="${roles[z].RoleID}">`;
                    }
                    roleshtml += "</div>";
                    roleshtml += `<a class=ews-tree-node-item><label for=SharingRole${roles[z].RoleID}>${roles[z].Role}</label></a>`;
                    roleshtml += "</div>";
                }
                html += `<div class=ews-tree-node>`;
                html += `<div class='ews-tree-trigger ews-tree-selector ${selectCount > 0 ? "ews-tree-expanded" : "ews-tree-collapsed"}'></div>`;
                html += `<div class='ews-tree-select-icon ews-tree-parent-node'><input type=checkbox usertype=${userType} id=Role_${userType} ${roles.length === selectCount ? "checked" : ""}></div>`;
                html += `<a><label for=Role_${userType}>${userType}</label></a>`;
                html += `<div class=ews-tree-child-node usertype=${userType} ${selectCount > 0 ? "style=display:block" : ""}>`;
                html += roleshtml;
                html += "</div>";
                html += "</div>";
            }
            html += "</div>";

            dialog.querySelector(".ews-savedreport-roles-display").innerHTML = html;
            const UserType = dialog.querySelector(".usertypeall");
            if (UserType) {
                UserType.addEventListener("click", (e) => {
                    const click = e.target;
                    if (!click || click.classList.contains("ews-savedreport-roles-container")) {
                        return;
                    }

                    if (click.classList.contains("ews-tree-trigger")) {
                        if (click.classList.contains("ews-tree-collapsed")) {
                            click.parentNode.querySelector(".ews-tree-child-node").style.display = "block";
                            click.classList.remove("ews-tree-collapsed");
                            click.classList.add("ews-tree-expanded");
                        } else {
                            click.parentNode.querySelector(".ews-tree-child-node").style.display = "";
                            click.classList.add("ews-tree-collapsed");
                            click.classList.remove("ews-tree-expanded");
                        }
                    }

                    if (!EC_Fmt.isNull(click.getAttribute("usertype"))) {
                        dialog.querySelectorAll(`.ews-tree-child-node[usertype='${click.getAttribute("usertype")}'] input[type='checkbox']`).forEach((input) => {
                            input.checked = event.target.checked;
                        });
                    }

                    const childusertype = click.closest(".ews-tree-child-node");
                    if (childusertype && EC_Fmt.isNull(click.getAttribute("usertype"))) {
                        let CheckParentAll = true;
                        const childusertypeinputarr = childusertype.querySelectorAll("input[type='checkbox']");
                        for (var i = 0; i < childusertypeinputarr.length; i++) {
                            if (!childusertypeinputarr[i].checked) {
                                CheckParentAll = false;
                                break;
                            }
                        }
                        const parentnode = childusertype.closest(".ews-tree-node").querySelector(".ews-tree-parent-node input[type='checkbox']")
                        if (CheckParentAll) {
                            parentnode.checked = true;
                        } else {
                            parentnode.checked = false;
                        }
                    }
                })
            }
        });
    });
};

BC_SavedReport.prototype.Run = function (id, system) {
    ECP.Dialog.ShowLoading();

    const myRequest = new ECP.EC_Request("SavedReport_GetReportUrl");

    myRequest.AddRequestVariable("ReportID", id);

    if (system) {
        myRequest.AddRequestVariable("System", "True");
    }

    myRequest.Submit().then((results) => {
        if (results.status === "success") {
            if (results.dashboard > 0) {
                window.location.href = `Home?DashboardID=${results.dashboard}&ParseFromReportURL=True&ReportID=${results.id}&ReportName=${encodeURIComponent(results.name)}`;
            } else {
                window.location.href = `${results.source}?ParseFromReportURL=True&ReportID=${results.id}&ReportName=${encodeURIComponent(results.name)}`;
            }
        } else {
            ECP.Dialog.HideLoading();
            ECP.Dialog.Alert(results.message);
        }
    }).catch((error) => {
        ECP.Dialog.HideLoading();
        throw error;
    });
};

BC_SavedReport.prototype.Save = function (url, id, permission, callback, urlProcessCallback) {
    const me = this;

    if (id && !EC_Fmt.isNull(parseInt(id))) {
        EWS.VerifySession(() => {
            const myRequest = new ECP.EC_Request("SavedReport_GetReport");

            myRequest.AddRequestVariable("ReportID", id);

            myRequest.Submit().then((result) => {
                if (result.error) {
                    EWS.HideLoading();
                    ECP.Dialog.Alert(result.error);
                    return;
                }
                if (result.draft) {
                    const args = {
                        id: parseInt(id),
                        url,
                        document: result.document,
                        owner: result.username,
                        ownerauthenticationid: result.ownerauthenticationid,
                        parentreportid: result.parentreportid,
                        format: result.format,
                        callback,
                        urlProcessCallback,
                        name: result.name
                    };

                    me.EWS.HideLoading();
                    me.Show_BC_SavedReport_SaveReport_Dialog(args);
                } else {
                    const roles = [];
                    const name = result.name;

                    for (let i = 0; i < result.roles.length; i++) {
                        roles.push(result.roles[i].id);
                    }

                    const format = result.format;

                    if (urlProcessCallback) {
                        url = urlProcessCallback(url, format);
                    }

                    const uri = url.split("?");
                    const source = uri[0].toUpperCase() == "API" ? "Home" : uri[0];

                    if (uri.length > 1) {
                        uri.shift();
                        url = uri.join("?");
                    } else {
                        url = "";
                    }

                    const mySubRequest = new ECP.EC_Request("SavedReport_SaveReport");
                    mySubRequest.Verb = ECP.EC_Verb.Post;

                    mySubRequest.AddRequestVariable("Request", "SaveReport", ECP.EC_Verb.Post);
                    mySubRequest.AddRequestVariable("ReportID", id, ECP.EC_Verb.Post);

                    if (result.document && result.document > 0) {
                        mySubRequest.AddRequestVariable("DocumentID", result.document, ECP.EC_Verb.Post);
                    }

                    mySubRequest.AddRequestVariable("Url", url, ECP.EC_Verb.Post);
                    mySubRequest.AddRequestVariable("SourcePage", source, ECP.EC_Verb.Post);
                    mySubRequest.AddRequestVariable("PagePermission", permission, ECP.EC_Verb.Post);
                    mySubRequest.AddRequestVariable("Report", name, ECP.EC_Verb.Post);
                    mySubRequest.AddRequestVariable("Category", result.category, ECP.EC_Verb.Post);
                    mySubRequest.AddRequestVariable("OwnerAuthenticationID", result.ownerauthenticationid, ECP.EC_Verb.Post);
                    mySubRequest.AddRequestVariable("Favorite", result.favorite, ECP.EC_Verb.Post);

                    if (result.link && result.link > 0) {
                        mySubRequest.AddRequestVariable("LinkFavoritesID", result.link, ECP.EC_Verb.Post);
                    }

                    mySubRequest.AddRequestVariable("RoleID", roles.join(), ECP.EC_Verb.Post);
                    mySubRequest.AddRequestVariable("Draft", "0", ECP.EC_Verb.Post);
                    mySubRequest.AddRequestVariable("Table", "Reports", ECP.EC_Verb.Post);
                    mySubRequest.AddRequestVariable("Format", format, ECP.EC_Verb.Post);

                    mySubRequest.Submit().then(() => {
                        if (callback && callback !== undefined) {
                            callback(id);
                        } else {
                            // Task 641114: ReportEdit page click SaveButton Always showing loading.
                            EWS.HideLoading();
                            ECP.Dialog.Alert("Report saved successfully.");
                        }
                    });
                }
            });
        });
    } else {
        this.SaveAs(url, null, permission, callback, urlProcessCallback);
    }
};

BC_SavedReport.prototype.SaveAs = function (url, id, permission, callback, urlProcessCallback) {
    const me = this;

    if (url && url !== "") {
        // Task 1043998: Can't Save report shared through quicklink
        const DashboardID = EC_Fmt.CDec(EC_Fmt.GetPageParameter("DashboardID"));
        if (id && !EC_Fmt.isNull(parseInt(id)) && (DashboardID === ECP.CommonDashboards.FusionView || DashboardID === ECP.CommonDashboards.FusionEdit)) {
            EWS.VerifySession(() => {
                // Task 726325: Save Fusion report is very very slow, and does not give the user a 'saving' message of any kind
                const myRequest = new ECP.EC_Request("SavedReport_GetReport");
                myRequest.AddRequestVariable("ReportID", id);
                myRequest.Submit().then((result) => {
                    if (result.error) {
                        EWS.HideLoading();
                        ECP.Dialog.Alert(result.error);
                        return;
                    }
                    const args = {
                        url,
                        permission,
                        name: result.name,
                        format: result.format,
                        category: result.category,
                        document: result.document,
                        ownerauthenticationid: result.ownerauthenticationid,
                        owner: result.username,
                        favorite: result.favorite,
                        link: result.link,
                        roles: result.roles,
                        callback,
                        original: id,
                        urlProcessCallback
                    };

                    ECP.Dialog.HideLoading();
                    me.Show_BC_SavedReport_SaveReport_Dialog(args);
                }).catch((error) => {
                    ECP.Dialog.HideLoading();
                    throw error;
                });
            });
        } else {
            EWS.VerifySession(() => {
                const myRequest = new ECP.EC_Request("SavedReport_GetCurrentUser");

                myRequest.Submit().then((result) => {
                    const args = {
                        url,
                        ownerauthenticationid: result.ownerauthenticationid,
                        owner: result.username,
                        format: result.format,
                        callback,
                        urlProcessCallback
                    };

                    ECP.Dialog.HideLoading();
                    me.Show_BC_SavedReport_SaveReport_Dialog(args);
                }).catch((error) => {
                    ECP.Dialog.HideLoading();
                    throw error;
                });
            });
        }
    } else {
        ECP.Dialog.HideLoading();
        ECP.Dialog.Alert(EC_Fmt.Trn("Invalid Report URL"));
    }
};

BC_SavedReport.prototype.SaveDraft = function (url, id, callback) {
    const me = this;

    if (url && url !== "") {
        if (id && !EC_Fmt.isNull(parseInt(id))) {
            EWS.VerifySession(() => {
                const myRequest = new ECP.EC_Request("SavedReport_GetReport");
                myRequest.AddRequestVariable("ReportID", id);

                myRequest.Submit().then((result) => {
                    if (result.error) {
                        EWS.HideLoading();
                        ECP.Dialog.Alert(result.error);
                        return;
                    }
                    if (result.draft) {
                        const args = {
                            id: parseInt(id),
                            url: "",
                            document: result.document,
                            owner: result.owner,
                            ownerauthenticationid: result.ownerauthenticationid,
                            callback,
                            method: "SaveDraft"
                        };

                        me.Show_BC_SavedReport_SaveReport_Dialog(args);
                    }
                });
            });
        }
    } else {
        ECP.Dialog.Alert(EC_Fmt.Trn("Invalid Report URL"));
    }
};

BC_SavedReport.prototype.Select = function (callback, selectCommand, title, report, owner, fullName, dashboard, ownerauthenticationid, multipleSelect, FilterPivot, ReportType) {
    if (multipleSelect) {
        this.SelectedReportIDArr = report ? report.split(",") : [];
    }

    this.Show_BC_SavedReport_ReportList_Dialog({
        callback,
        selectCommand,
        title,
        report,
        owner,
        fullName,
        ownerauthenticationid,
        dashboard,
        multipleSelect,
        FilterPivot,
        ReportType
    });
};

BC_SavedReport.prototype.SelectReport = function (callback, selectCommand, parentReport, fusion) {
    this.Show_BC_SavedReport_FusionAddReport_Dialog({
        callback,
        selectCommand,
        parentReport,
        fusion
    });
};

EWS.Ready((EWS) => {
    EWS.SavedReport = new BC_SavedReport(EWS);
});

function Report_Save(url, id, permission, callback, urlProcessCallback) {
    if (EWS && EWS.SavedReport) {
        EWS.SavedReport.Save(url, id, permission, callback, urlProcessCallback);
    }
}

function Report_SaveAs(url, id, permission, callback, urlProcessCallback) {
    if (EWS && EWS.SavedReport) {
        EWS.SavedReport.SaveAs(url, id, permission, callback, urlProcessCallback);
    }
}

function Report_SaveDraft(url, id, callback) {
    if (EWS && EWS.SavedReport) {
        EWS.SavedReport.SaveDraft(url, id, callback);
    }
}

BC_SavedReport.prototype.Show_BC_SavedReport_SaveReport_Dialog = function (args) {
    const me = this;

    if (!args) {
        args = {};
    }

    const saveReportArgs = args;

    EWS.VerifySession(() => {
        const myRequest = new ECP.EC_Request("SavedReport_SaveDialog");
        myRequest.AddRequestVariable("Mobile", EC_Fmt.isMobile);
        // Task 690648: Fusion Report Format: Fusion report is running in HTML format when the Format is set to CSV.
        myRequest.AddRequestVariable("DashboardID", EC_Fmt.GetPageParameter("DashboardID"));
        // Task 748410: Fusion View: Click Save Report As refreshes report, but no Save As Dialogue pops up
        const LoadingDialogTimeout = setTimeout(() => {
            ECP.Dialog.ShowLoading("Loading Dialog...");
        }, 500);
        myRequest.Submit().then((result) => {
            const Dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 750,
                height: 550,
                cancelButtonTitle: result.cancel,
                confirmButtonTitle: result.save,
                confirmButtonAction(dialog) {
                    EWS.ShowLoading();

                    const report = dialog.querySelector("#SavedReportName").value;

                    if (report !== "") {
                        let format = "";
                        let SaveURL = dialog.querySelector("#SavedReportUrl").value;

                        const UrlArr = EC_Fmt.GetURLParameters(SaveURL);
                        let DashboardID = "";
                        if (UrlArr.DashboardID) {
                            DashboardID = UrlArr.DashboardID;
                        }
                        const DashboardFormat = (EC_Fmt.GetPageParameter("DashboardID") === ECP.CommonDashboards.FusionView.toString()) || (EC_Fmt.GetPageParameter("DashboardID") === ECP.CommonDashboards.FusionEdit.toString());
                        if (Dialog.querySelector("#SavedReportFormat") || !DashboardFormat) {
                            if (!EC_Fmt.isMobile) {
                                format = dialog.querySelector("#SavedReportFormat").value;
                            } else {
                                format = dialog.querySelector("input[name='SavedReportFormat']:checked").value;
                            }
                        }

                        if (saveReportArgs.urlProcessCallback) {
                            SaveURL = saveReportArgs.urlProcessCallback(SaveURL, format);
                        }

                        const uri = SaveURL.split("?");
                        // Task 920004: Saved report 3615248 - running the report, some are getting specific errors, but running the report now gives a long list of errors.
                        const source = uri[0].toUpperCase() == "API" ? "Home" : uri[0];
                        let url = "";

                        if (uri.length > 1) {
                            uri.shift();
                            url = uri.join("?");
                        }
                        // Task 645424: Change FusionEdit.aspx to Dashboard
                        // Task 676375: In SaveReportAS, add the parameter DashboardID

                        if (source === "Home" && !EC_Fmt.isInteger(DashboardID)) {
                            ECP.Dialog.Alert("Saved DashboardID Error");
                            ECP.Dialog.HideLoading();
                            return;
                        }
                        const _myRequest = new ECP.EC_Request("SavedReport_SaveReport");
                        _myRequest.Verb = ECP.EC_Verb.Post;

                        _myRequest.AddRequestVariable("ReportID", dialog.querySelector("#SavedReportReportID").value, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("DocumentID", dialog.querySelector("#SavedReportDocumentID").value, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("DashboardID", DashboardID, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("SourcePage", source, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("Url", url, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("PagePermission", dialog.querySelector("#SavedReportPermission").value, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("Report", report, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("Category", dialog.querySelector("#SavedReportCategoryHidden").value, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("OwnerAuthenticationID", dialog.querySelector("#OwnerAuthenticationIDHidden").value, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("OriginalReportID", dialog.querySelector("#SavedReportOriginalReportID").value, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("Favorite", "0", ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("LinkFavoritesID", dialog.querySelector("#SavedReportLinkID").value, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("Draft", "0", ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("Table", "Reports", ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("Format", format, ECP.EC_Verb.Post);

                        const selectedRoles = [];

                        const checkedRoles = Dialog.querySelectorAll(".ews-savedreport-roles-display input[type='checkbox']:checked");
                        for (let i = 0, len = checkedRoles.length; i < len; i++) {
                            selectedRoles.push(checkedRoles[i].value);
                        }

                        _myRequest.AddRequestVariable("RoleID", selectedRoles.join(), ECP.EC_Verb.Post);

                        ECP.Dialog.CloseDialog(dialog);

                        _myRequest.Submit().then((myResult) => {
                            if (format === "Excel" || format === "PDF" || format === "XML" || format === "JSON") {
                                EWS.HideLoading();
                            }

                            if (saveReportArgs.callback && saveReportArgs.callback !== undefined) {
                                saveReportArgs.callback(myResult.id, report);
                            } else if (saveReportArgs.parentreportid > 0) {
                                window.location.href = `Home?DashboardID=${ECP.CommonDashboards.FusionEdit}&ReportID=${saveReportArgs.parentreportid}&ChildReportID=${saveReportArgs.id}`;
                            } else if (saveReportArgs.SaveMethod && saveReportArgs.SaveMethod === "SaveDraft") {
                                window.location.reload();
                            } else {
                                // Task 631270: Export of a Compound report uses the name of one of the base reports, not the name of the Compound report
                                window.location = `${source}?ParseFromReportURL=True&ReportID=${myResult.id}&ReportName=${encodeURIComponent(report)}`;
                                // Task 644859: Get error with Invalid report action (). when save a table report
                            }
                        }).catch((error) => {
                            EWS.HideLoading();
                            throw error;
                        });
                    } else {
                        EWS.HideLoading();
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must enter a report name."));
                    }
                }
            });

            if (EC_Fmt.isMobile) {
                Dialog.firstChild.classList.add("ecp-dialog-mobile");
            }

            const ajaxInputs = Dialog.querySelectorAll("input[KeyValue][DisplayVal][LimitToList]");
            for (let i = 0, len = ajaxInputs.length; i < len; i++) {
                const input = ajaxInputs[i];
                const FieldID = input.closest("section").getAttribute("FieldID");

                EWS.AjaxInputs[FieldID] = new ECP.HTML.AjaxInput(input);

                input.closest("table").style.width = "";
            }

            if (Dialog.querySelector("#ews-savedreport-roles-select-all")) {
                Dialog.querySelector("#ews-savedreport-roles-select-all").addEventListener("click", (event) => {
                    Dialog.querySelectorAll(".ews-savedreport-roles-display input[type='checkbox']").forEach((input) => {
                        input.checked = event.target.checked;
                    });
                });
            }

            Dialog.querySelector("#SavedReportReportID").value = saveReportArgs.id || "";

            if (saveReportArgs.document && saveReportArgs.document > 0) {
                Dialog.querySelector("#SavedReportDocumentID").value = saveReportArgs.document;
            } else {
                Dialog.querySelector("#SavedReportDocumentID").value = "";
            }

            Dialog.querySelector("#SavedReportReportID").value = saveReportArgs.id || "";
            Dialog.querySelector("#SavedReportUrl").value = saveReportArgs.url || "";
            Dialog.querySelector("#SavedReportPermission").value = saveReportArgs.permission || "";
            Dialog.querySelector("#SavedReportName").value = saveReportArgs.name || "";
            Dialog.querySelector("#SavedReportCategoryHidden").value = saveReportArgs.category || "";
            Dialog.querySelector("#SavedReportCategoryInput").value = saveReportArgs.category || "";
            Dialog.querySelector("#SavedReportOriginalReportID").value = saveReportArgs.original || "";

            // Task 603764: User set Report Format to Null on Inventory Status Report
            if (saveReportArgs.format && saveReportArgs.format.toLowerCase() === "") {
                saveReportArgs.format = "HTML";
            }
            const DashboardID = (EC_Fmt.GetPageParameter("DashboardID") === ECP.CommonDashboards.FusionView.toString()) || (EC_Fmt.GetPageParameter("DashboardID") === ECP.CommonDashboards.FusionEdit.toString());
            if (Dialog.querySelector("#SavedReportFormat") || !DashboardID) {
                if (!EC_Fmt.isMobile) {
                    Dialog.querySelector("#SavedReportFormat").value = saveReportArgs.format || "";
                } else {
                    Dialog.querySelector("input[name='SavedReportFormat']:checked").checked = false;
                    Dialog.querySelector(`input[name='SavedReportFormat'][value='${saveReportArgs.format || ""}']`).checked = true;
                }
            }

            if (saveReportArgs.link && saveReportArgs.link > 0) {
                Dialog.querySelector("#SavedReportLinkID").value = saveReportArgs.link;
            } else {
                Dialog.querySelector("#SavedReportLinkID").value = "";
            }

            const checkedRoles = Dialog.querySelectorAll(".ews-savedreport-roles-display input[type='checkbox']:checked");
            for (let i = 0, len = checkedRoles.length; i < len; i++) {
                checkedRoles[i].checked = false;
            }

            clearTimeout(LoadingDialogTimeout);
            ECP.Dialog.HideLoading();

            me.LoadRoles(Dialog);
        }).catch((e) => {
            clearTimeout(LoadingDialogTimeout);
            EWS.HideLoading();
            throw e;
        });
    });
};

BC_SavedReport.prototype.Show_BC_SavedReport_EditReport_Dialog = function (args) {
    const me = this;

    EWS.VerifySession(() => {
        const myRequest = new ECP.EC_Request("SavedReport_EditDialog");
        myRequest.AddRequestVariable("Mobile", EC_Fmt.isMobile);
        // Task 690648: Fusion Report Format: Fusion report is running in HTML format when the Format is set to CSV.
        myRequest.AddRequestVariable("DashboardID", args.DashboardID);

        myRequest.Submit().then((result) => {
            const Dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 750,
                height: 550,
                cancelButtonTitle: result.cancel,
                confirmButtonTitle: result.save,
                confirmButtonAction(dialog) {
                    EWS.ShowLoading();

                    if (dialog.querySelector("#SavedReportName").value !== "") {
                        const data = new FormData();

                        if (data) {
                            let format = "";
                            // Task 927264: When saving a comparison report on a mobile device on safari, the default format = HTML is not saving as expected
                            const DashboardID = (args.DashboardID === ECP.CommonDashboards.FusionView.toString()) || (args.DashboardID === ECP.CommonDashboards.FusionEdit.toString());
                            if (Dialog.querySelector("#SavedReportFormat") || !DashboardID) {
                                if (!EC_Fmt.isMobile) {
                                    format = dialog.querySelector("#SavedReportFormat").value;
                                } else {
                                    format = dialog.querySelector("input[name='SavedReportFormat']:checked").value;
                                }
                            }

                            const mySubRequest = new ECP.EC_Request("SavedReport_SaveReport", ECP.EC_Verb.Post);

                            mySubRequest.AddRequestVariable("ReportID", dialog.querySelector("#SavedReportReportID").value, ECP.EC_Verb.Post);
                            // Task 678816: Comparison Sales Report: Report Record Dashboard ID is being updated when saved or edited
                            mySubRequest.AddRequestVariable("Url", "", ECP.EC_Verb.Post);
                            mySubRequest.AddRequestVariable("DocumentID", dialog.querySelector("#SavedReportDocumentID").value, ECP.EC_Verb.Post);
                            mySubRequest.AddRequestVariable("Report", dialog.querySelector("#SavedReportName").value, ECP.EC_Verb.Post);
                            mySubRequest.AddRequestVariable("Category", dialog.querySelector("#SavedReportCategoryHidden").value, ECP.EC_Verb.Post);
                            mySubRequest.AddRequestVariable("OwnerAuthenticationID", dialog.querySelector("#OwnerAuthenticationIDHidden").value, ECP.EC_Verb.Post);
                            mySubRequest.AddRequestVariable("Favorite", "0", ECP.EC_Verb.Post);
                            mySubRequest.AddRequestVariable("LinkFavoritesID", dialog.querySelector("#SavedReportLinkID").value, ECP.EC_Verb.Post);
                            mySubRequest.AddRequestVariable("Draft", "0", ECP.EC_Verb.Post);
                            mySubRequest.AddRequestVariable("Table", "Reports", ECP.EC_Verb.Post);
                            mySubRequest.AddRequestVariable("Format", format, ECP.EC_Verb.Post);

                            const selectedRoles = [];

                            dialog.querySelectorAll(".ews-savedreport-roles-display input[type='checkbox']:checked").forEach((input) => {
                                selectedRoles.push(input.value);
                            });

                            mySubRequest.AddRequestVariable("RoleID", selectedRoles.join(), ECP.EC_Verb.Post);

                            ECP.Dialog.CloseDialog(dialog);

                            mySubRequest.Submit().then(() => {
                                if (format === "Excel" || format === "PDF" || format === "XML" || format === "JSON") {
                                    EWS.HideLoading();
                                }

                                window.location.reload();
                            }).catch((error) => {
                                EWS.HideLoading();
                                throw error;
                            });
                        }
                    } else {
                        EWS.HideLoading();
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must enter a report name."));
                    }
                }
            });

            if (EC_Fmt.isMobile) {
                Dialog.firstChild.classList.add("ecp-dialog-mobile");
            }

            Dialog.querySelectorAll("input[KeyValue][DisplayVal][LimitToList]").forEach((input) => {
                const FieldID = input.closest("section").getAttribute("FieldID");

                EWS.AjaxInputs[FieldID] = new ECP.HTML.AjaxInput(input);

                input.closest("table").style.width = "";
            });

            if (Dialog.querySelector("#ews-savedreport-roles-select-all")) {
                Dialog.querySelector("#ews-savedreport-roles-select-all").addEventListener("click", (event) => {
                    Dialog.querySelectorAll(".ews-savedreport-roles-display input[type='checkbox']").forEach((input) => {
                        input.checked = event.target.checked;
                    });
                });
            }

            if (!args) {
                args = {};
            }

            Dialog.querySelector("#SavedReportReportID").value = args.id || "";

            if (args.document && args.document > 0) {
                Dialog.querySelector("#SavedReportDocumentID").value = args.document;
            } else {
                Dialog.querySelector("#SavedReportDocumentID").value = "";
            }

            Dialog.querySelector("#SavedReportUrl").value = "";
            Dialog.querySelector("#SavedReportPermission").value = "";
            Dialog.querySelector("#SavedReportName").value = args.name || "";
            Dialog.querySelector("#SavedReportCategoryHidden").value = args.category || "";
            Dialog.querySelector("#SavedReportCategoryInput").value = args.category || "";
            const DashboardID = (args.DashboardID === ECP.CommonDashboards.FusionView.toString()) || (args.DashboardID === ECP.CommonDashboards.FusionEdit.toString());
            if (Dialog.querySelector("#SavedReportFormat") || !DashboardID) {
                if (!EC_Fmt.isMobile) {
                    Dialog.querySelector("#SavedReportFormat").value = args.format || "";
                } else {
                    Dialog.querySelector("input[name='SavedReportFormat']:checked").checked = false;
                    Dialog.querySelector(`input[name='SavedReportFormat'][value='${args.format || ""}']`).checked = true;
                }
            }

            if (args.link && args.link > 0) {
                Dialog.querySelector("#SavedReportLinkID").value = args.link;
            } else {
                Dialog.querySelector("#SavedReportLinkID").value = "";
            }

            Dialog.querySelectorAll(".ews-savedreport-roles-display input[type='checkbox']:checked").forEach((input) => {
                input.checked = false;
            });

            if (args.roles) {
                const roles = [];

                for (let i = 0; i < args.roles.length; i++) {
                    roles.push(args.roles[i].id);
                }

                me.LoadRoles(Dialog, roles);
            } else {
                me.LoadRoles(Dialog);
            }
        }).catch((e) => {
            EWS.HideLoading();
            throw e;
        });
    });
};

BC_SavedReport.prototype.Show_BC_SavedReport_FusionAddReport_Dialog = function (args) {
    const me = this;

    EWS.VerifySession(async () => {
        const selectArgs = args;
        const ReportLayers = await CheckFusionReportLayers(args.parentReport);
        if (!ReportLayers) {
            return;
        }
        const myRequest = new ECP.EC_Request("SavedReport_ReportListDialog");
        try {
            const result = await myRequest.Submit();
            me.UserName = result.username;
            me.FullName = result.fullname;
            me.OwnerAuthenticationID = result.ownerauthenticationid;
            const Dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 750,
                height: 730,
                cancelButtonTitle: result.cancel,
                confirmButtonTitle: result.select,
                async confirmButtonAction(dialog) {
                    EWS.ShowLoading();
                    requestAnimationFrame(() => {
                        if (document.querySelector("#ews-loading-mask")) {
                            document.querySelector("#ews-loading-mask").style.zIndex = parseInt(dialog.style.zIndex) + 30;
                        }
                    });

                    const radio = dialog.querySelector("input[name='saved-report']:checked");

                    let report = radio.value;
                    // Task 662223: Prevent users from adding more than 3 layers of reports to a fusion report
                    const CheckSaveReportLayers = await CheckFusionReportLayers(report, true);
                    if (!CheckSaveReportLayers) {
                        return;
                    }
                    if (CheckSaveReportLayers + ReportLayers > 3) {
                        ECP.Dialog.Alert("No more than 3 layers allowed in a Fusion Report");
                        EWS.HideLoading();
                        return;
                    }


                    const title = dialog.querySelector("#ews-report-title").value.replace(/(^\s*)|(\s*$)/g, "");

                    if (selectArgs.dashboard && title === "") {
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must enter a title."));
                        return;
                    }

                    if (selectArgs.report && !EC_Fmt.isNull(parseInt(selectArgs.report)) && !report) {
                        report = selectArgs.report;
                    }

                    const source = radio.getAttribute("source");
                    const owner = radio.getAttribute("owner");
                    let fullName = radio.getAttribute("fullname");

                    if (report && !EC_Fmt.isNull(parseInt(report))) {
                        if (owner.length > 0 && owner.substr(owner.length - 1) === "$") {
                            fullName = owner;
                        }

                        const _myRequest = new ECP.EC_Request("FluxEdit_CloneReport");
                        _myRequest.AddRequestVariable("ReportID", report, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("ParentReportID", selectArgs.parentReport, ECP.EC_Verb.Post);
                        _myRequest.AddRequestVariable("Alias", title, ECP.EC_Verb.Post);

                        _myRequest.Submit().then((myResult) => {
                            if (selectArgs.callback && selectArgs.callback !== undefined) {
                                ECP.Dialog.CloseDialog(dialog);

                                EWS.HideLoading();

                                selectArgs.callback(me, myResult.report, title, source, owner, fullName);
                            }
                        }).catch((e) => {
                            EWS.HideLoading();
                            throw e;
                        });
                    } else {
                        EWS.HideLoading();
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must select a report."));
                    }
                }
            });

            let manualTitle = false;

            Dialog.querySelectorAll("input[KeyValue][DisplayVal][LimitToList]").forEach((input) => {
                const FieldID = input.closest("section").getAttribute("FieldID");

                EWS.AjaxInputs[FieldID] = new ECP.HTML.AjaxInput(input);

                input.closest("table").style.width = "";
            });

            Dialog.querySelector("#ews-report-title").addEventListener("keyup", () => {
                manualTitle = true;
            });

            Dialog.querySelector("#ews-report-display").addEventListener("change", (event) => {
                const target = event.target;

                if (target.tagName.toLowerCase() === "input" && target.name === "saved-report") {
                    Dialog.querySelectorAll(".ews-tree-selected").forEach((item) => {
                        item.classList.remove("ews-tree-selected");
                    });

                    const reportTitle = Dialog.querySelector("#ews-report-title");

                    if (reportTitle.value === "") {
                        manualTitle = false;
                    }

                    if (!manualTitle) {
                        reportTitle.value = target.closest(".ews-tree-node").querySelector("a[type=report]").innerHTML;
                    }

                    // Task 677137: Syntax Error when selecting a saved report from table import
                    target.closest(".ews-tree-node").querySelector("a[type=report]").classList.add("ews-tree-selected");
                }
            });


            if (selectArgs.title) {
                Dialog.querySelector("#ews-report-title").value = selectArgs.title;
            }

            if (selectArgs.dashboard) {
                Dialog.querySelector("#ews-saved-report-title-container").style.display = "flex";
            } else if (selectArgs.fusion) {
                Dialog.querySelector("#ews-saved-report-title-container").style.display = "flex";
                Dialog.querySelector("#ews-saved-report-title-display").text = EC_Fmt.Trn("Alias");
                Dialog.querySelector(".ews-report-owner").style.display = "";
            } else {
                Dialog.querySelector("#ews-saved-report-title-container").style.display = "none";
            }

            let selectCommand = "BC_SavedReport_GetReports";

            if (selectArgs.selectCommand && selectArgs.selectCommand !== undefined && selectArgs.selectCommand !== "") {
                selectCommand = selectArgs.selectCommand;
            }

            let DashboardID = "";
            if (document.querySelector("#ews-report-dashboard-id")) {
                DashboardID = document.querySelector("#ews-report-dashboard-id").value;
            }

            EWS.Command.Execute(selectCommand, {
                Dialog,
                ownerauthenticationid: Dialog.querySelector("#ews-report-ownerauthenticationHidden").value,
                search: Dialog.querySelector("#ews-report-search").value,
                report: selectArgs.report,
                userName: (me.UserName || "").toLowerCase(),
                DashboardID
            });

            Dialog.querySelector("#ews-report-ownerauthenticationHidden").addEventListener("change", () => {
                EWS.Command.Execute(selectCommand, {
                    Dialog,
                    ownerauthenticationid: Dialog.querySelector("#ews-report-ownerauthenticationHidden").value,
                    search: Dialog.querySelector("#ews-report-search").value,
                    report: selectArgs.report,
                    userName: (me.UserName || "").toLowerCase(),
                    DashboardID
                });
            });

            Dialog.querySelector("#ews-report-search").addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    EWS.Command.Execute(selectCommand, {
                        Dialog,
                        ownerauthenticationid: Dialog.querySelector("#ews-report-ownerauthenticationHidden").value,
                        search: Dialog.querySelector("#ews-report-search").value,
                        report: selectArgs.report,
                        userName: (me.UserName || "").toLowerCase(),
                        DashboardID
                    });

                    return false;
                }
                return true;
            });

            Dialog.querySelector(".ews-edit-form").addEventListener("click", (event) => {
                const target = event.target;

                if (target.tagName.toLowerCase() === "a" && target.type === "report") {
                    target.parentNode.querySelector("input[name='saved-report']").click();
                } else if (target.tagName.toLowerCase() === "a" && target.type === "folder") {
                    target.parentNode.querySelector(".ews-tree-selector").click();
                } else if (target.classList.contains("ews-tree-collapsed")) {
                    target.parentNode.querySelector(".ews-tree-child-node").style.display = "block";

                    target.classList.add("ews-tree-expanded");
                    target.classList.remove("ews-tree-collapsed");
                } else if (target.classList.contains("ews-tree-expanded")) {
                    target.parentNode.querySelector(".ews-tree-child-node").style.display = "none";

                    target.classList.remove("ews-tree-expanded");
                    target.classList.add("ews-tree-collapsed");
                }
            });

            Dialog.querySelector("#ews-report-search-button").addEventListener("click", () => {
                EWS.Command.Execute(selectCommand, {
                    Dialog,
                    ownerauthenticationid: Dialog.querySelector("#ews-report-ownerauthenticationHidden").value,
                    search: Dialog.querySelector("#ews-report-search").value,
                    report: selectArgs.report,
                    userName: (me.UserName || "").toLowerCase(),
                    DashboardID
                });
            });

            Dialog.querySelector("#ews-report-search").focus();

            requestAnimationFrame(() => {
                Dialog.querySelector("#ews-report-search").focus();
            });
        } catch (e) {
            EWS.HideLoading();
            throw (e);
        }
    });
};

BC_SavedReport.prototype.Show_BC_SavedReport_ReportList_Dialog = function (args) {
    const me = this;

    EWS.VerifySession(() => {
        const selectArgs = args;

        const myRequest = new ECP.EC_Request("SavedReport_ReportListDialog");

        myRequest.Submit().then((result) => {
            me.UserName = result.username;
            me.FullName = result.fullname;
            me.OwnerAuthenticationID = result.ownerauthenticationid;

            const Dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 750,
                height: 730,
                cancelButtonTitle: result.cancel,
                confirmButtonTitle: result.select,
                confirmButtonAction(dialog) {
                    let closeDialog = true;
                    const inputArr = dialog.querySelectorAll("input[name='saved-report']:checked");

                    const title = dialog.querySelector("#ews-report-title").value.replace(/(^\s*)|(\s*$)/g, "");

                    if (selectArgs.dashboard && title === "") {
                        ECP.Dialog.Alert(EC_Fmt.Trn("You must enter a title."));
                        return;
                    }

                    if (selectArgs.multipleSelect) {
                        if (inputArr.length <= 0) {
                            ECP.Dialog.Alert(EC_Fmt.Trn("You must select a report."));
                            closeDialog = false;
                        }

                        if (selectArgs.callback && selectArgs.callback !== undefined) {
                            selectArgs.callback(me, Array.from(inputArr).map(input => input.value).join(","), title);
                        }
                    } else {
                        const radio = inputArr.length > 0 ? inputArr[0] : null;

                        if (radio) {
                            let report = radio.value;

                            if (selectArgs.report && !EC_Fmt.isNull(parseInt(selectArgs.report)) && !report) {
                                report = selectArgs.report;
                            }

                            const source = radio.getAttribute("source");
                            const owner = radio.getAttribute("owner");
                            let fullName = radio.getAttribute("fullname");

                            if (report && !EC_Fmt.isNull(parseInt(report))) {
                                if (owner.length > 0 && owner.substr(owner.length - 1) === "$") {
                                    fullName = owner;
                                }

                                if (selectArgs.callback && selectArgs.callback !== undefined) {
                                    selectArgs.callback(me, report, title, source, owner, fullName);
                                }
                            }
                        } else {
                            ECP.Dialog.Alert(EC_Fmt.Trn("You must select a report."));
                            closeDialog = false;
                        }
                    }

                    if (!closeDialog) {
                        dialog.style.display = "block";
                    } else {
                        ECP.Dialog.CloseDialog(dialog);
                    }
                }
            });

            let manualTitle = false;

            Dialog.querySelectorAll("input[KeyValue][DisplayVal][LimitToList]").forEach((input) => {
                const FieldID = input.closest("section").getAttribute("FieldID");

                EWS.AjaxInputs[FieldID] = new ECP.HTML.AjaxInput(input);

                input.closest("table").style.width = "";
            });

            Dialog.querySelector("#ews-report-title").addEventListener("keyup", () => {
                manualTitle = true;
            });

            Dialog.addEventListener("change", (event) => {
                const target = event.target;

                if (target.tagName.toLowerCase() === "input" && target.name === "saved-report") {
                    Dialog.querySelectorAll(".ews-tree-selected").forEach((item) => {
                        item.classList.remove("ews-tree-selected");
                    });

                    if (Dialog.querySelector("#ews-report-title").value === "") {
                        manualTitle = false;
                    }

                    if (!manualTitle) {
                        Dialog.querySelector("#ews-report-title").value = target.parentNode.parentNode.querySelector("a[type=report]").innerHTML;
                    }

                    // Task 677137: Syntax Error when selecting a saved report from table import
                    target.parentNode.parentNode.querySelector("a[type=report]").classList.add("ews-tree-selected");
                }
            });

            if (selectArgs.title) {
                Dialog.querySelector("#ews-report-title").value = selectArgs.title;
            }

            if (selectArgs.dashboard) {
                Dialog.querySelector("#ews-saved-report-title-container").style.display = "flex";
            } else if (selectArgs.fusion) {
                Dialog.querySelector("#ews-saved-report-title-container").style.display = "none";
                Dialog.querySelector(".ews-report-owner").style.display = "none";
            } else {
                Dialog.querySelector("#ews-saved-report-title-container").style.display = "none";
            }

            if (selectArgs.owner) {
                Dialog.querySelector("#ews-report-ownerauthenticationHidden").value = selectArgs.ownerauthenticationid;
                Dialog.querySelector("#ews-report-ownerauthenticationInput").value = selectArgs.owner;
            }

            let selectCommand = "BC_SavedReport_GetReports";

            if (selectArgs.selectCommand && selectArgs.selectCommand !== undefined && selectArgs.selectCommand !== "") {
                selectCommand = selectArgs.selectCommand;
            }

            EWS.Command.Execute(selectCommand, {
                Dialog,
                ownerauthenticationid: Dialog.querySelector("#ews-report-ownerauthenticationHidden").value,
                search: Dialog.querySelector("#ews-report-search").value,
                report: selectArgs.report,
                userName: (me.UserName || "").toLowerCase(),
                DashboardID: args.ReportType,
                multipleSelect: selectArgs.multipleSelect,
                FilterPivot: selectArgs.FilterPivot
            });

            Dialog.querySelector("#ews-report-ownerauthenticationHidden").addEventListener("change", () => {
                EWS.Command.Execute(selectCommand, {
                    Dialog,
                    ownerauthenticationid: Dialog.querySelector("#ews-report-ownerauthenticationHidden").value,
                    search: Dialog.querySelector("#ews-report-search").value,
                    report: selectArgs.report,
                    userName: (me.UserName || "").toLowerCase(),
                    DashboardID: args.ReportType,
                    FilterPivot: selectArgs.FilterPivot
                });
            });

            Dialog.querySelector("#ews-report-search").addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    EWS.Command.Execute(selectCommand, {
                        Dialog,
                        ownerauthenticationid: Dialog.querySelector("#ews-report-ownerauthenticationHidden").value,
                        search: Dialog.querySelector("#ews-report-search").value,
                        report: selectArgs.report,
                        userName: (me.UserName || "").toLowerCase(),
                        DashboardID: args.ReportType,
                        FilterPivot: selectArgs.FilterPivot
                    });

                    return false;
                }
                return true;
            });

            Dialog.querySelector("#ews-report-search").focus();

            Dialog.addEventListener("click", (event) => {
                const target = event.target;

                if (target.tagName.toLowerCase() === "a" && target.type === "report") {
                    target.parentNode.querySelector("input[name='saved-report']").click();
                } else if (target.tagName.toLowerCase() === "a" && target.type === "folder") {
                    target.parentNode.querySelector(".ews-tree-selector").click();
                } else if (target.classList.contains("ews-tree-collapsed")) {
                    target.parentNode.querySelector(".ews-tree-child-node").style.display = "block";

                    target.classList.add("ews-tree-expanded");
                    target.classList.remove("ews-tree-collapsed");
                } else if (target.classList.contains("ews-tree-expanded")) {
                    target.parentNode.querySelector(".ews-tree-child-node").style.display = "none";

                    target.classList.remove("ews-tree-expanded");
                    target.classList.add("ews-tree-collapsed");
                }
            });

            Dialog.querySelector("#ews-report-search-button").addEventListener("click", () => {
                EWS.Command.Execute(selectCommand, {
                    Dialog,
                    ownerauthenticationid: Dialog.querySelector("#ews-report-ownerauthenticationHidden").value,
                    search: Dialog.querySelector("#ews-report-search").value,
                    report: selectArgs.report,
                    userName: (me.UserName || "").toLowerCase(),
                    DashboardID: args.ReportType,
                    multipleSelect: selectArgs.multipleSelect,
                    FilterPivot: selectArgs.FilterPivot
                });
            });

            requestAnimationFrame(() => {
                Dialog.querySelector("#ews-report-search").focus();
            });
        });
    });
};

BC_SavedReport.prototype.Show_BC_SavedReport_ReportConflicts_Dialog = function (args) {
    const me = this;

    EWS.VerifySession(() => {
        const myRequest = new ECP.EC_Request("SavedReport_ReportListDialog");

        myRequest.Submit().then((result) => {
            const Dialog = ECP.Dialog.ShowDialog(result.title, result.content, {
                width: 745,
                height: 550,
                cancelButtonTitle: result.cancel,
                confirmButtonTitle: result.save,
                confirmButtonAction(dialog) {
                    ECP.HTML.CloseDialog(dialog);
                }
            });

            // ADD CALLBACK
            // ADD REPORT CONFLICT LIST
            // ADD CONFLICTED ACTIONS
        });
    });
};
